<div class="space-y-6">
  <app-page-header [backTo]="['/permissions/resources']" backLabel="Retour aux resources" />

  @if (loadError() || loading()) {
    <app-data-state
      [loading]="loading()"
      [error]="loadError()"
      (retry)="fetch()"
    />
  } @else if (resource(); as r) {
    <section class="rounded-2xl border border-gray-200 bg-white p-5 shadow-theme-xs dark:border-gray-800 dark:bg-white/[0.03]">
      <div class="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div class="min-w-0">
          <h1 class="font-mono text-title-sm font-bold text-gray-800 dark:text-white/90 sm:text-title-md">{{ r.name }}</h1>
          @if (r.displayName && r.displayName !== r.name) {
            <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">{{ r.displayName }}</p>
          }
          <div class="mt-2 flex flex-wrap gap-2">
            @if (r.type) {
              <span class="inline-flex items-center rounded-full bg-gray-100 px-2 py-0.5 text-[10px] font-medium text-gray-700 dark:bg-gray-800 dark:text-gray-300">{{ r.type }}</span>
            }
            @if (r.ownerManagedAccess) {
              <span class="inline-flex items-center rounded-full bg-warning-50 px-2 py-0.5 text-[10px] font-medium text-warning-700 dark:bg-warning-500/15 dark:text-warning-400">Owner-managed</span>
            }
          </div>
        </div>
        <div class="flex flex-wrap gap-2">
          <a [routerLink]="['/permissions/resources', r.id, 'edit']" class="inline-flex items-center gap-2 rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 transition hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-white/5">Modifier</a>
          <button type="button" (click)="openDelete()" class="inline-flex items-center gap-2 rounded-lg border border-error-300 px-4 py-2 text-sm font-medium text-error-700 transition hover:bg-error-50 dark:border-error-800 dark:text-error-400 dark:hover:bg-error-500/10">Supprimer</button>
        </div>
      </div>
    </section>

    <div class="grid grid-cols-1 gap-6 lg:grid-cols-2">
      <section class="rounded-2xl border border-gray-200 bg-white p-5 shadow-theme-xs dark:border-gray-800 dark:bg-white/[0.03]">
        <h2 class="mb-4 text-sm font-semibold text-gray-800 dark:text-white/90">URIs</h2>
        @if (r.uris?.length) {
          <ul class="space-y-1">
            @for (u of r.uris; track u) {
              <li class="rounded-md bg-gray-50 px-3 py-2 font-mono text-xs text-gray-700 break-all dark:bg-gray-800 dark:text-gray-300">{{ u }}</li>
            }
          </ul>
        } @else { <p class="text-xs text-gray-500 dark:text-gray-400">Aucune URI.</p> }
      </section>

      <section class="rounded-2xl border border-gray-200 bg-white p-5 shadow-theme-xs dark:border-gray-800 dark:bg-white/[0.03]">
        <h2 class="mb-4 text-sm font-semibold text-gray-800 dark:text-white/90">Scopes</h2>
        @if (r.scopes?.length) {
          <ul class="flex flex-wrap gap-1.5">
            @for (s of r.scopes; track s.id || s.name) {
              <li><span class="inline-flex items-center rounded-md bg-brand-50 px-2 py-1 font-mono text-[11px] text-brand-700 dark:bg-brand-500/15 dark:text-brand-400">{{ s.name }}</span></li>
            }
          </ul>
        } @else { <p class="text-xs text-gray-500 dark:text-gray-400">Aucun scope rattaché.</p> }
      </section>

      <section class="rounded-2xl border border-gray-200 bg-white p-5 shadow-theme-xs dark:border-gray-800 dark:bg-white/[0.03] lg:col-span-2">
        <h2 class="mb-4 text-sm font-semibold text-gray-800 dark:text-white/90">Identifiants Keycloak</h2>
        <dl class="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div><dt class="text-xs uppercase tracking-wide text-gray-500 dark:text-gray-400">ID</dt><dd class="mt-1 break-all font-mono text-xs text-gray-700 dark:text-gray-300">{{ r.id || '—' }}</dd></div>
          <div><dt class="text-xs uppercase tracking-wide text-gray-500 dark:text-gray-400">Owner</dt><dd class="mt-1 text-sm text-gray-700 dark:text-gray-300">{{ r.owner || '—' }}</dd></div>
        </dl>
      </section>
    </div>
  }
</div>

<app-confirm-modal
  [open]="deleteOpen()"
  [busy]="deleting()"
  [error]="deleteError()"
  title="Supprimer la resource ?"
  confirmLabel="Supprimer définitivement"
  busyLabel="Suppression…"
  danger
  (confirm)="confirmDelete()"
  (close)="closeDelete()"
>
  <span class="font-mono font-medium text-gray-700 dark:text-gray-300">{{ resource()?.name }}</span> sera retiré. Les permissions qui la ciblent peuvent devenir invalides.
</app-confirm-modal>
